import type {
	ProductProjection,
	ProductVariant,
} from "@commercetools/platform-sdk";
import { mergeVariants } from "../storyblok/product-variant";

export const getVariantAttributeValue = <T>(
	variant: ProductVariant,
	key: string,
): T | undefined => {
	return variant.attributes?.find((attribute) => {
		return attribute.name === key ? true : false;
	})?.value as T;
};

export const getGiftOptionsVariant = (
	product: ProductProjection,
): ProductVariant => {
	const allVariants = mergeVariants(product.masterVariant, product.variants);

	const availableVariant = allVariants.find((variant) => {
		return Object.values(variant.availability?.channels || {}).some(
			(channel) => channel.isOnStock,
		);
	});

	return availableVariant ?? product.masterVariant;
};
